<div class="popup-window">
  <div class="icon-container">
    <div
      class="acronym-icon"
      [matTooltip]="notification?.createdBy?.firstName + ' ' + notification?.createdBy?.lastName"
      >
      <span>{{ getAcronym(notification) }}</span>
    </div>
  </div>

  <div class="content" style="width: 90%">
    <div class="header">
      <strong>{{ notification?.notificationTitle }}</strong>
      @if (popup) {
        <button
          mat-icon-button
          (click)="closeNotification(notification)"
          style="float: right; transform: scale(0.9)"
          >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    <div class="text">
      <div>
        {{ notification?.notificationText }}
      </div>
      <div style="width: 100%; text-align: right; color: #777; font-size: 0.8em">
        {{ formatDate(notification?.createdAt) }}
      </div>
    </div>
  </div>
</div>
